'use client';

/* Lazy wrapper around InstantSiteScene. The heavy implementation lives in
 * ./InstantSiteScene.impl. See ./lazyScene.js for why scenes are lazy-mounted. */

import {lazyScene} from './lazyScene';

const InstantSiteScene = lazyScene(() => import('./InstantSiteScene.impl'), {minH: 460});

export default InstantSiteScene;
